<template>
  <div class="nav" :class="'nav--' + (status ? 'show' : 'hide')">
    <div class="qrcode-download">
      <img :src="require('@/assets/img/nav_qrcode_download.png')">
      <span>扫码下载游戏</span>
    </div>
    <div class="btn-change" :class="'btn-change--' + (status ? 'show' : 'hide')" @click="changeStatus">
      <span class="icon">{{ btnIcon }}</span>
      <span class="text">{{ btnText }}</span>
    </div>
    <div class="list">
      <ul>
        <li v-for="(item, key) in navList" :key="key" class="item" @click="scrollTo(item.height)">
          <span>{{ item.name }}</span>
        </li>
      </ul>
    </div>
    <div class="qrcode-wechat">
      <img :src="require('@/assets/img/nav_qrcode_wechat.png')">
      <span>官方公众号</span>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  data() {
    return {
      // status: true,
      navList: [
        {
          name: '首页',
          height: 0,
        },
        {
          name: '源空快讯',
          height: 1095,
        },
        {
          name: '源像呈现',
          height: 2125,
        },
        {
          name: '源能特色',
          height: 3200,
        },
        {
          name: '源能社区',
          height: 4410,
        },
      ],
    }
  },
  computed: {
    btnIcon() {
      return this.status ? '›' : '‹'
    },
    btnText() {
      return this.status ? '收起' : '展开'
    },
    status() {
      return this.$store.getters.navShow
    },
  },
  methods: {
    ...mapMutations(['setNavShow']),
    changeStatus() {
      this.setNavShow({ visible: !this.status })
      // this.status = !this.status
    },
    // 滚动到指定板块
    scrollTo(height) {
      document.documentElement.scrollTo({
        top: height,
        behavior: 'smooth',
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.nav {
  position: fixed;
  z-index: 10;
  top: 50%;
  transform: translateY(-50%);
  width: 212px;
  height: 754px;
  background: url('~@/assets/img/bg_nav.png') no-repeat;
  transition: all .3s ease;

  &--show {
    right: 0;
  }
  &--hide {
    right: -212px;
  }

  .qrcode-download {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    top: 53px;
    left: 50%;
    transform: translateX(-50%);
    width: 163px;

    span {
      margin-top: 5px;
      font-size: 20px;
      color: #fff;
      text-shadow: 0 0 5px rgb(23, 209, 255), 0 0 10px rgb(23, 209, 255);
    }
  }

  .list {
    position: absolute;
    top: 276px;
    left: 3px;
    width: 207px;

    .item {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 53px;
      cursor: pointer;

      &::after {
        content: '';
        position: absolute;
        bottom: 3px;
        width: 100%;
        height: 1px;
        background: #000;
      }

      &:hover {
        background: url('~@/assets/img/bg_active_nav.png') no-repeat;

        span {
          color: #00ffff;
        }
      }

      span {
        font-size: 24px;
        color: transparent;
        background: linear-gradient(180deg, #fff, #fff, #8affff);
        -webkit-background-clip: text;
        background-clip: text;
      }
    }
  }

  .qrcode-wechat {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    top: 565px;
    left: 50%;
    transform: translateX(-50%);
    width: 125px;

    span {
      margin-top: 5px;
      font-size: 20px;
      color: #fff;
      text-shadow: 0 0 5px rgb(23, 209, 255), 0 0 10px rgb(23, 209, 255);
    }
  }

  .btn-change {
    position: absolute;
    left: -18px;
    bottom: 83px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 3px;
    width: 21px;
    height: 82px;
    color: #fff;
    background: url('~@/assets/img/btn_nav.png') no-repeat;
    cursor: pointer;

    .icon {
      font-size: 21px;
    }

    .text {
      font-size: 14px;
      letter-spacing: 5px;
      writing-mode: vertical-lr;
    }

    span {
      text-shadow: 0 0 5px rgb(23, 209, 255), 0 0 10px rgb(23, 209, 255);
    }
  }
}
</style>
